import { Controller } from "@hotwired/stimulus"
import { beacon, pulse } from "../lib/tally"

// A split tool's introduction (tools/intro): counts the visit, and a click on an Open link, as ToolTally's intro and
// open, each at most once a page, and tells Umami as tool-intro and tool-open. Nothing but the tool and the kind is
// sent (lib/tally.js), and a look at the page is never taken for a run of the tool.
export default class extends Controller {
  static values = { slug: String }

  connect() {
    this.sent = new Set()
    // Turbo's preview of a cached page isn't a visit.
    if (!document.documentElement.hasAttribute("data-turbo-preview")) this.count("intro")
  }

  open() {
    this.count("open")
  }

  count(kind) {
    if (this.sent.has(kind) || !/^[a-z0-9-]+$/.test(this.slugValue)) return
    this.sent.add(kind)
    beacon(this.slugValue, kind)
    pulse(this.slugValue, kind)
  }
}
